import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { ResourceTypeItem, ResourceItem } from "@ServerTypes/resources/resources.schema";

const resourceTypesSlice = createSlice({
  name: "resourceTypes",
  initialState: [] as ResourceTypeItem[],
  reducers: {
    setTaskResourceType: (_state: ResourceTypeItem[], action: PayloadAction<ResourceTypeItem[]>) =>
      action.payload,
  },
});

const resourcesSlice = createSlice({
  name: "resources",
  initialState: [] as ResourceItem[],
  reducers: {
    setTaskResource: (_state: ResourceItem[], action: PayloadAction<ResourceItem[]>) => action.payload,
  },
});

const resourceCreatedSlice = createSlice({
  name: "resourceCreated",
  initialState: false,
  reducers: {
    setResourceCreated: (_state: boolean, action: PayloadAction<boolean>) => action.payload,
  },
});

export const { setTaskResourceType } = resourceTypesSlice.actions;
export const { setTaskResource } = resourcesSlice.actions;
export const { setResourceCreated } = resourceCreatedSlice.actions;

export const resourceTypes = resourceTypesSlice.reducer;
export const resources = resourcesSlice.reducer;
export const resourceCreated = resourceCreatedSlice.reducer;

export default {
  resourceTypes,
  resources,
  resourceCreated,
};
